// If a swiper is on the page, fetch the init code and init the swiper
export const initSwiperMount = async () => {
	const swipers = document.querySelectorAll('[data-fn="initSwiper"]');
	if (swipers.length) {
		const initSwiper = (await import("shared/vanilla/initSwiper")).default;
		swipers.forEach(swiper => {
			initSwiper(swiper);
		});
	}
};